import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { OmniValidators } from '../../../../../shared/validators';
import { Util } from '../../../../../utils/util';
import { Bank } from '../../../../models/banks';
import { AccountOwnership } from '../../../models/account-ownership.enum';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { TransfersOtherBanksService } from '../../../../transfers-other-banks/transfers-other-banks.service';
import { PixPaymentFavored, PixPaymentFavoredAccount } from '../../../models/payment-favored.model';
import { PixPaymentFavoredView } from '../../../models/payment-favored-view.model';
import { PixPaymentKeyService } from '../../payment-key.service';
import { PixKeyType } from '../../../models/key-type.enum';
import { User } from '../../../../../autentication/models/user';
import { Auth } from '../../../../../autentication/Auth';
@Component({
	selector: 'app-pix-payment-key-favored-create-agency-account',
	templateUrl: './agency-account.component.html',
	styleUrls: ['./agency-account.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixPaymentKeyFavoredCreateAgencyAccountComponent implements OnInit {

	public form: FormGroup;
	public submited = false;
	public filteredBanks: Observable<Bank[]>;
	private banks: Array<Bank> = [];
	public selectedPixPaymentFavoredView: PixPaymentFavoredView;
	public user: User;

	constructor(
		private route: ActivatedRoute,
		private formBuilder: FormBuilder,
		private router: Router,
		private transferOBService: TransfersOtherBanksService,
		private pixPaymentKeyService: PixPaymentKeyService,
	) {}

	ngOnInit(): void {
		this.user = Auth.getInstance().getUser();
		this.getBanks();
		this.buildForm();
	}

	buildForm() {
		this.form = this.formBuilder.group({
			createType: [AccountOwnership.DIFFERENT, Validators.required],
			bank: ['', [Validators.required]],
			typeAccount: ['', [Validators.required]],
			agency: ['', [Validators.required]],
			number: ['', [Validators.required]],
			cpfCnpj: ['', [Validators.required, Validators.minLength(14), OmniValidators.isValidCpfCnpj]],
			name: ['', [Validators.required, OmniValidators.whiteSpace, OmniValidators.completeName]],
			saveFavored: [false]
		});
	}

	submit() {
		if (this.form.valid) {
			const model = this.convertFormToModel();
			model.tipoChave = PixKeyType.MANUAL;
			model.toSave = this.form.get('saveFavored').value;
			this.pixPaymentKeyService.setSelectedPixPaymentFavoredView(model);
			this.router.navigate(['pix/pagamento/favorecido/adicionar/valor-data']);
		}
	}

	convertFormToModel() {
		const bank = this.form.get('bank').value;
		const code = bank.ispbCode;
		const nameBank = bank.name;
		const model = new PixPaymentFavored();
		model.conta = new PixPaymentFavoredAccount();
		model.conta.tipoConta = this.form.get('typeAccount').value;
		model.conta.numeroAgencia = this.form.get('agency').value;
		model.conta.numeroConta = Util.removeNonNumerics(this.form.get('number').value);
		model.conta.documento = this.form.get('cpfCnpj').value;
		model.conta.iSPBCodigo = code;
		model.conta.iSPBNome = nameBank;
		model.conta.nome = this.form.get('name').value;

		return new PixPaymentFavoredView(model);
	}

	changeType(e: any) {
		this.form.get('createType').setValue(e.value);

		if (this.form.get('createType').value === AccountOwnership.DIFFERENT) {
			this.form.get('cpfCnpj').setValidators([Validators.required, Validators.minLength(14), OmniValidators.isValidCpfCnpj]);
			this.form.get('name').setValidators([Validators.required, OmniValidators.whiteSpace, OmniValidators.completeName]);
			this.form.get('cpfCnpj').updateValueAndValidity();
			this.form.get('name').updateValueAndValidity();
			this.form.get('cpfCnpj').setValue('');
			this.form.get('name').setValue('');
		} else {
			this.form.get('cpfCnpj').setValue(this.user.cpfCnpj);
			this.form.get('name').setValue(this.user.name);
			this.form.get('cpfCnpj').setValidators(null);
			this.form.get('name').setValidators(null);
			this.form.get('cpfCnpj').updateValueAndValidity();
			this.form.get('name').updateValueAndValidity();
		}
	}

	public get accountOwnership(): typeof AccountOwnership {
		return AccountOwnership;
	}

	isCPF(): boolean {
		return this.form.controls.cpfCnpj.value == null ? true : this.form.controls.cpfCnpj.value.length < 12 ? true : false;
	}

	getCpfCnpjMask(): string {
		return this.isCPF() ? '000.000.000-009' : Util.NGX_MASK_CNPJ;
	}

	validateBank(e) {
		if (e.source !== undefined) {
			this.form.controls['bank'].setErrors(null);
		} else {
			this.form.controls['bank'].setErrors({ 'incorrect': true });
		}
	}

	autoCompleteDisplay(bank: Bank): any {
		return bank ? bank.label : bank;
	}

	getBanks() {
		this.transferOBService.getBanks().subscribe(data => {

			this.banks = data;
			this.filteredBanks = this.form.controls.bank.valueChanges.pipe(
				startWith({} as Bank),
				map(bank => bank && typeof bank === 'object' ? bank.label : bank),
				map(label => label ? this.filter(label) : this.banks.slice())
			);
		});
	}

	filter(val): Bank[] {
		return this.banks.filter(bank => bank.label.includes(val));
	}

	cpfcnpjKeydown(event: KeyboardEvent) {
		Util.handleCpfCnpjKeydown(event);
	}

	cpfcnpjPaste(event) {
		event.preventDefault();
		const clipboardData = event.clipboardData;
		const pastedText = Util.removeMaskCharacters(clipboardData.getData('text').trim());
		this.setMaskAndValidatorToCpfCnpj(pastedText);
	}

	cpfcnpjMask(event) {
		if (!event.target.value || event.keyCode === 8) {
			return;
		}
		this.setMaskAndValidatorToCpfCnpj(Util.removeMaskCharacters(event.target.value));
	}

	setMaskAndValidatorToCpfCnpj(value: string) {
		const masked = Util.maskCpfCnpj(value);
		if (masked.length <= 14) {
			this.form.controls.cpfCnpj.setValidators([Validators.required, Validators.minLength(14)]);
		} else {
			this.form.controls.cpfCnpj.setValidators([Validators.required, Validators.minLength(18), OmniValidators.isValidCpfCnpj]);
		}
		this.form.controls.cpfCnpj.updateValueAndValidity();
		this.form.controls.cpfCnpj.setValue(masked);
	}

	destinationAccountMask(event) {
		if (!event.target.value) {
			return;
		}
		if (event.keyCode === 8) {
			return;
		}

		const newVal = Util.maskAccount(event.target.value);
		this.form.get('number').setValue(newVal);

	}

	goBack = () => this.router.navigate(['pix/pagamento']);

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/payment-key/favored-create/agency-account/agency-account.component.ts